<template>
  <div class="card">
    <div class="card-body">
      <b-form-group>
        <div
          v-for="(sponsor, index) in localSponsors"
          :key="'sponsor' + index"
          class="mb-2"
        >
          <!-- Название + удалить -->
          <div class="links">
            <b-col md="6">
              <div class="flex-wrapper">
                <svg
                  width="16"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="minus"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  class="svg-inline--fa fa-minus fa-w-14"
                  @click="removeSponsor(index)"
                >
                  <path
                    d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                  />
                </svg>

                <b-form-input
                  v-model="sponsor.name"
                  placeholder="Название"
                  class="links__input"
                />
              </div>
            </b-col>

            <!-- Сайт -->
            <b-col md="6">
              <b-form-input
                v-model="sponsor.site"
                placeholder="Сайт"
                class="links__input"
              />
            </b-col>
          </div>

          <!-- Лого -->
          <div>
            <b-col
              md="6"
              style="margin: 20px 0"
            >
              <file-uploader
                v-model="sponsor.file_id"
                :default="sponsor.file"
                title="Логотип"
              />
            </b-col>
          </div>
        </div>

        <!-- Добавить -->
        <b-button
          variant="primary"
          class="mr-1"
          @click="addSponsor"
        >
          Добавить спонсора
        </b-button>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import { BFormGroup, BFormInput, BCol, BButton } from 'bootstrap-vue'
import FileUploader from '@/global-components/FileUploader.vue'

export default {
  name: 'SponsorsSection',

  components: {
    BFormGroup,
    BFormInput,
    BCol,
    BButton,
    FileUploader,
  },

  props: {
    sponsors: { type: Array, required: true },
  },

  computed: {
    localSponsors: {
      get() {
        return this.sponsors
      },
      set(val) {
        this.$emit('update:sponsors', val)
      },
    },
  },

  methods: {
    addSponsor() {
      this.localSponsors = [
        ...this.localSponsors,
        { name: '', site: '', file_id: null, logo: {} },
      ]
    },
    removeSponsor(i) {
      const arr = [...this.localSponsors]
      arr.splice(i, 1)
      this.localSponsors = arr
    },
  },
}
</script>

<style scoped lang="scss">
.links {
  display: flex;
  align-items: center;
  svg {
    transition: 0.3s;
    &:hover {
      cursor: pointer;
      transform: scale(1.3);
    }
  }
  &__input {
    margin: 10px 0;
    &:nth-child(2) {
      margin: 10px 10px;
    }
  }
}
.fa-minus path {
  fill: #b4b7bd;
}
.flex-wrapper {
  display: flex;
}
</style>
